import request from '@/utils/request'


// 查询创造者认证列表
export function listCreate(query) {
  return request({
    url: '/create/create/list',
    method: 'get',
    params: query
  })
}

// 查询创造者认证分页
export function pageCreate(query) {
  return request({
    url: '/create/create/page',
    method: 'get',
    params: query
  })
}

// 查询创造者认证详细
export function getCreate(data) {
  return request({
    url: '/create/create/detail',
    method: 'get',
    params: data
  })
}

// 新增创造者认证
export function addCreate(data) {
  return request({
    url: '/create/create/add',
    method: 'post',
    data: data
  })
}

// 修改创造者认证
export function updateCreate(data) {
  return request({
    url: '/create/create/edit',
    method: 'post',
    data: data
  })
}

// 删除创造者认证
export function delCreate(data) {
  return request({
    url: '/create/create/delete',
    method: 'post',
    data: data
  })
}
